import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = ["title", "onClick"]
const _hoisted_3 = {
  key: 0,
  class: "icon"
}
const _hoisted_4 = ["src", "alt"]

import { ref, toRefs, computed } from 'vue'
import Icon from '@/components/CommonUI/Icon.vue'

interface Props {
  options: DropdownOption[],
  selectedOptionId: number,
  small?: boolean,
  scrollable?: boolean,
  toggleClass?: string,
  toggleIcon?: string | null,
  toggleText?: string,
  disabled?: boolean,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DropdownUI',
  props: {
    options: {},
    selectedOptionId: {},
    small: { type: Boolean, default: false },
    scrollable: { type: Boolean, default: false },
    toggleClass: { default: '' },
    toggleIcon: { default: null },
    toggleText: { default: '' },
    disabled: { type: Boolean, default: false }
  },
  emits: ["selected"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const {
  options,
  toggleText,
} = toRefs(props)

const isOpened = ref(false)
const selectedOptionId = ref(props.selectedOptionId)
const optionLabel = computed(() => {
  const option = options.value.find(({ id }) => id === selectedOptionId.value)

  return option?.name || toggleText.value
})

const emit = __emit

function selectOption(option: DropdownOption) {
  if (option.disabled) return

  selectedOptionId.value = option.id
  emit('selected', option.id)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dropdown", { small: __props.small, open: isOpened.value }])
  }, [
    _createElementVNode("a", {
      href: "#",
      title: _unref(toggleText),
      class: _normalizeClass(["dropdown-toggle", { [__props.toggleClass]: __props.toggleClass, disabled: __props.disabled }]),
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
    }, [
      (__props.toggleIcon)
        ? (_openBlock(), _createBlock(Icon, {
            key: 0,
            name: __props.toggleIcon
          }, null, 8, ["name"]))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(optionLabel.value) + " ", 1),
      _cache[1] || (_cache[1] = _createElementVNode("b", { class: "caret" }, null, -1))
    ], 10, _hoisted_1),
    _createElementVNode("ul", {
      class: _normalizeClass(["dropdown-menu", __props.scrollable ? `dropdown-menu-scrollable` : ``])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(options), (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: `${item.name}`
        }, [
          _createElementVNode("a", {
            title: item.name,
            href: "#",
            class: _normalizeClass({ disabled: item.disabled }),
            onClick: _withModifiers(($event: any) => (selectOption(item)), ["prevent"])
          }, [
            (item.iconPath)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                  _createElementVNode("img", {
                    src: item.iconPath,
                    alt: item.iconPath
                  }, null, 8, _hoisted_4)
                ]))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(item.name), 1)
          ], 10, _hoisted_2)
        ]))
      }), 128))
    ], 2)
  ], 2))
}
}

})